import React from 'react'
import SVGIcon from '../svg/SVGIcon'
import classnames from 'classnames'
import s from './SearchInputIcon.less'
import { useSelector } from 'react-redux'
import { selectGeoentityIconDataForSearch } from '../../store/poiassets/poiassets.selectors'

function SearchInputIcon() {
  const { iconId, mob_roundImage } = useSelector(selectGeoentityIconDataForSearch)
  if (iconId) return <SVGIcon icon={iconId} className={classnames(s.common, s.icon)} />
  if (mob_roundImage) return <img src={mob_roundImage} className={classnames(s.common)} />
  return <></>
}

export default SearchInputIcon
